<!-- 공통 파일 첨부 컴포넌트 (eony, 2022/06/09) -->
<template>
  <div>
    <div>
      <v-list flat class="add-box-list">
        <v-list-item-group>
          <v-list-item v-for="(file, i) in fileList" :key="i" class="px-4">
            <v-list-item-content @click="fileView(file)">
              <v-list-item-title>
                <file-img-icon v-bind:fileType="getFileType(file)" />
                <span v-text="file.rFileNm"></span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>
<script>
//const bizMOB = window.bizMOB;
/* 첨부파일 추가 컴포넌트 */
import FileImgIcon from '@/components/common/FileImgIcon.vue';
import { mapGetters } from 'vuex';
import _file from '@/js/file';

export default {
  data: () => ({
    fileList: [],
    fileSeq: 0,
  }),

  computed: {
    ...mapGetters(['GET_USER_DATA', 'GET_FILE_SEQ']),
  },

  methods: {
    async fileListRefresh() {

      this.options = {
        searchType: 'file',
        enterCd: this.GET_USER_DATA.ssnEnterCd,
        fileSeq: this.GET_FILE_SEQ,
      };

      this.fileList = await _file.search(this.options);
      if (this.fileList.data !== undefined) {
        this.fileList = this.fileList.data.data;
      }

      this.$store.commit('SET_FILE_SEQ', this.options.fileSeq);
      //this.$forceUpdate();
    },

    async deleteFile(file) {
      if (confirm('삭제 하시겠습니까?')) {
        await _file.delete(file.enterCd, file.fileSeq, file.seqNo);
        this.fileListRefresh();
      }
    },

    fileView(files) {
      _file.fileView(files);
    },

    getFileType(file) {
      const fileName = file.rFileNm.split('.');
      return fileName[fileName.length - 1];
    },
  },

  created() {
    this.fileListRefresh();
  },

  components: {
    FileImgIcon,
  },
};
</script>

<style></style>
